"use client";
import { f as L } from "./floating-ui.utils-CqK2Pznf.mjs";
import { s as w } from "./event-CXjJudzK.mjs";
import { A as k, a as D, b as y, d as A } from "./element-DE7VsBMX.mjs";
function E(r, n, a) {
  return Math.floor(r / n) !== a;
}
function C(r, n) {
  return n < 0 || n >= r.current.length;
}
function F(r, n) {
  return o(r, {
    disabledIndices: n
  });
}
function P(r, n) {
  return o(r, {
    decrement: !0,
    startingIndex: r.current.length,
    disabledIndices: n
  });
}
function o(r, {
  startingIndex: n = -1,
  decrement: a = !1,
  disabledIndices: u,
  amount: g = 1
} = {}) {
  let t = n;
  do
    t += a ? -g : g;
  while (t >= 0 && t <= r.current.length - 1 && M(r, t, u));
  return t;
}
function T(r, {
  event: n,
  orientation: a,
  loop: u,
  rtl: g,
  cols: t,
  disabledIndices: e,
  minIndex: O,
  maxIndex: s,
  prevIndex: f,
  stopEvent: h = !1
}) {
  let i = f;
  if (n.key === k) {
    if (h && w(n), f === -1)
      i = s;
    else if (i = o(r, {
      startingIndex: i,
      amount: t,
      decrement: !0,
      disabledIndices: e
    }), u && (f - t < O || i < 0)) {
      const m = f % t, c = s % t, G = s - (c - m);
      c === m ? i = s : i = c > m ? G : G - t;
    }
    C(r, i) && (i = f);
  }
  if (n.key === D && (h && w(n), f === -1 ? i = O : (i = o(r, {
    startingIndex: f,
    amount: t,
    disabledIndices: e
  }), u && f + t > s && (i = o(r, {
    startingIndex: f % t - t,
    amount: t,
    disabledIndices: e
  }))), C(r, i) && (i = f)), a === "both") {
    const m = L(f / t);
    n.key === (g ? y : A) && (h && w(n), f % t !== t - 1 ? (i = o(r, {
      startingIndex: f,
      disabledIndices: e
    }), u && E(i, t, m) && (i = o(r, {
      startingIndex: f - f % t - 1,
      disabledIndices: e
    }))) : u && (i = o(r, {
      startingIndex: f - f % t - 1,
      disabledIndices: e
    })), E(i, t, m) && (i = f)), n.key === (g ? A : y) && (h && w(n), f % t !== 0 ? (i = o(r, {
      startingIndex: f,
      decrement: !0,
      disabledIndices: e
    }), u && E(i, t, m) && (i = o(r, {
      startingIndex: f + (t - f % t),
      decrement: !0,
      disabledIndices: e
    }))) : u && (i = o(r, {
      startingIndex: f + (t - f % t),
      decrement: !0,
      disabledIndices: e
    })), E(i, t, m) && (i = f));
    const c = L(s / t) === m;
    C(r, i) && (u && c ? i = n.key === (g ? A : y) ? s : o(r, {
      startingIndex: f - f % t - 1,
      disabledIndices: e
    }) : i = f);
  }
  return i;
}
function U(r, n, a) {
  const u = [];
  let g = 0;
  return r.forEach(({
    width: t,
    height: e
  }, O) => {
    if (t > n && process.env.NODE_ENV !== "production")
      throw new Error(`[Floating UI]: Invalid grid - item width at index ${O} is greater than grid columns`);
    let s = !1;
    for (a && (g = 0); !s; ) {
      const f = [];
      for (let h = 0; h < t; h += 1)
        for (let i = 0; i < e; i += 1)
          f.push(g + h + i * n);
      g % n + t <= n && f.every((h) => u[h] == null) ? (f.forEach((h) => {
        u[h] = O;
      }), s = !0) : g += 1;
    }
  }), [...u];
}
function j(r, n, a, u, g) {
  if (r === -1)
    return -1;
  const t = a.indexOf(r), e = n[r];
  switch (g) {
    case "tl":
      return t;
    case "tr":
      return e ? t + e.width - 1 : t;
    case "bl":
      return e ? t + (e.height - 1) * u : t;
    case "br":
      return a.lastIndexOf(r);
    default:
      return -1;
  }
}
function z(r, n) {
  return n.flatMap((a, u) => r.includes(a) ? [u] : []);
}
function M(r, n, a) {
  if (typeof a == "function")
    return a(n);
  if (a)
    return a.includes(n);
  const u = r.current[n];
  return u == null || u.hasAttribute("disabled") || u.getAttribute("aria-disabled") === "true";
}
export {
  P as a,
  T as b,
  U as c,
  j as d,
  z as e,
  o as f,
  F as g,
  C as h,
  M as i
};
